import React from "react";
import "../styles/Privacy.css";

export default function PrivacyPolicy() {
    return (
        <div className="container">
            <h1 className="title">POLITYKA PRYWATNOŚCI SYSTEMU „SYSTEM ARRIO – PSDiA”</h1>
            <p className="meta">Polityka prywatności systemu „System Arrio – PSDiA” (Wersja 0.0.33)<br />Ostatnia aktualizacja: 1 grudnia 2025 r.</p>

            <Section title="§ 1. Postanowienia ogólne">
                <ol>
                    <li>
                        Niniejsza polityka prywatności (dalej: „Polityka”) określa zasady przetwarzania
                        danych osobowych użytkowników systemu „System Arrio – PSDiA” (dalej: „System”),
                        prowadzonego przez Fundację Polska Szkoła Dendrologii i Arborystyki.
                    </li>
                    <li>
                        Polityka ma charakter informacyjny i realizuje obowiązek informacyjny administratora
                        danych, o którym mowa w art. 13 rozporządzenia Parlamentu Europejskiego i Rady
                        (UE) 2016/679 z dnia 27 kwietnia 2016 r. („RODO”).
                    </li>
                    <li>
                        System jest przeznaczony wyłącznie dla osób pełnoletnich. Osoby, które nie
                        ukończyły 18 roku życia, nie powinny zakładać konta ani przekazywać swoich
                        danych za pośrednictwem Systemu.
                    </li>
                    <li>
                        Korzystanie z Systemu wymaga akceptacji <strong>Regulaminu Systemu Arrio – PSDiA </strong>
                        (dalej: „Regulamin”). Regulamin określa w szczególności zasady świadczenia usług
                        drogą elektroniczną oraz warunki korzystania z Systemu.
                    </li>
                    <li>
                        Niniejsza Polityka ma charakter uzupełniający wobec Regulaminu i dotyczy
                        wyłącznie kwestii przetwarzania danych osobowych.
                    </li>
                    <li>
                        Przed rozpoczęciem korzystania z Systemu użytkownik zobowiązany jest zapoznać
                        się zarówno z Regulaminem, jak i z niniejszą Polityką.
                    </li>
                </ol>
            </Section>

            <Section title="§ 2. Administrator danych">
                <ol>
                    <li>Administratorem danych osobowych użytkowników Systemu (dalej: „Administrator”) jest:
                        <strong> Fundacja Polska Szkoła Dendrologii i Arborystyki</strong>
                        <ul>
                            <li>ul. Cieszyńska 71, 43-300 Bielsko-Biała</li>
                            <li>KRS: 0000856513</li>
                            <li>NIP: 5472220438</li>
                        </ul>
                    </li>
                    <li>
                        Z Administratorem można skontaktować się w sprawach związanych z ochroną
                        danych osobowych za pośrednictwem poczty elektronicznej:
                        <strong> sekretariat@szkoladendrologii.pl</strong>.
                    </li>
                </ol>
            </Section>

            <Section title="§ 3. Zakres przetwarzanych danych">
                <p>W związku z korzystaniem z Systemu Administrator może przetwarzać następujące kategorie danych osobowych użytkowników:</p>
                <ol>
                    <strong><li>dane identyfikacyjne:</li></strong>
                    <ol>
                        <li>imię i nazwisko,</li>
                        <li>w uzasadnionych przypadkach – numer PESEL, gromadzony tymczasowo, w szczególności na potrzeby organizacji zajęć lub potwierdzania tożsamości;</li>
                    </ol>
                    <strong><li>dane kontaktowe:</li></strong>
                    <ol>
                        <li>adres poczty elektronicznej (adres e-mail),</li>
                        <li>numer telefonu;</li>
                    </ol>
                    <strong><li>dane dodatkowe związane z realizacją zajęć dydaktycznych:</li></strong>
                    <ol>
                        <li>data urodzenia (tymczasowo, m.in. na potrzeby organizacyjne)</li>
                        <li>zdjęcie (tymczasowo, np. jako element identyfikacji w ramach grupy kursowej);</li>
                    </ol>
                    <strong><li>dane związane z kontem w Systemie:</li></strong>
                    <ol>
                        <li>login,</li>
                        <li> hasło (przechowywane w postaci zaszyfrowanej, z wykorzystaniem standardu bcrypt),</li>
                        <li>informacje o przynależności do grup, klas, kursów oraz dane wynikające z przebiegu udziału w zajęciach;</li>
                    </ol>
                    <strong><li>dane techniczne i eksploatacyjne:</li></strong>
                    <ol>
                        <li>adres IP,</li>
                        <li>dane urządzenia i przeglądarki (w szczególności typ i wersja),</li>
                        <li>znaczniki czasu (logi systemowe: data i godzina logowania oraz wykonanych operacji),</li>
                        <li>dane zawarte w plikach cookie niezbędnych do prawidłowego działania Systemu.</li>
                    </ol>
                </ol>
            </Section>

            <Section title="§ 4. Źródło danych">
                <ol>
                    <li>Dane osobowe są co do zasady pozyskiwane bezpośrednio od użytkownika wzwiązku z:</li>
                    <ol>
                        <li>zakładaniem konta w Systemie,</li>
                        <li>uzupełnianiem profilu,</li>
                        <li>udziałem w kursach lub innych formach aktywności prowadzonych przez Fundację.</li>
                    </ol>
                    <li>
                        W uzasadnionych przypadkach dane mogą zostać przekazane Administratorowi przez podmiot współpracujący (w szczególności organizatora grupy szkoleniowej), o
                        czym użytkownik zostaje poinformowany w odpowiedniej komunikacji.
                    </li>
                </ol>
            </Section>

            <Section title="§ 5. Cele i podstawy prawne przetwarzania danych">
                <ol>
                    <li>Dane osobowe użytkowników mogą być przetwarzane w następujących celach, na podstawie niżej wskazanych podstaw prawnych:</li>
                    <ol>
                        <li>
                            <strong>założenie i obsługa konta w Systemie, umożliwienie korzystania z jego funkcjonalności oraz udział w kursach i zajęciach dydaktycznych </strong>
                            – na podstawie niezbędności do wykonania umowy lub do podjęcia działań na żądanie użytkownika przed zawarciem umowy (art. 6 ust. 1 lit. b RODO);
                        </li>
                        <li>
                            <strong>organizacja procesu dydaktycznego i zarządzanie kursami</strong> (przypisanie
                            do zajęć, dokumentowanie udziału, rozliczanie kursów, komunikacja organizacyjna) – na podstawie:
                            <ul>
                                <li>niezbędności do wykonania umowy (art. 6 ust. 1 lit. b RODO),</li>
                                <li>
                                    w zakresie, w jakim wynika to z przepisów prawa – wypełniania obowiązku
                                    prawnego ciążącego na Administratorze (art. 6 ust. 1 lit. c RODO, jeżeli ma zastosowanie);
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>komunikacja z użytkownikami</strong> (odpowiadanie na zapytania, powiadomienia
                            systemowe, informacje dotyczące organizacji zajęć oraz funkcjonowania Systemu) – na podstawie:
                            <ul>
                                <li>niezbędności do wykonania umowy (art. 6 ust. 1 lit. b RODO),</li>
                                <li>uzasadnionego interesu Administratora polegającego na zapewnieniu sprawnej komunikacji (art. 6 ust. 1 lit. f RODO);</li>
                            </ul>
                        </li>
                        <li>
                            <strong>prowadzenie podstawowych statystyk dotyczących korzystania z Systemu oraz jego doskonalenie </strong>
                            (analiza aktywności użytkowników w celu poprawy działania Systemu) – na podstawie uzasadnionego interesu
                            Administratora polegającego na doskonaleniu Systemu (art. 6 ust. 1 lit. f RODO);
                        </li>
                        <li>
                            <strong>zapewnienie bezpieczeństwa Systemu oraz ochrona przed nadużyciami </strong>
                            (monitorowanie logów, wykrywanie prób nieuprawnionego dostępu,
                            przeciwdziałanie naruszeniom) – na podstawie uzasadnionego interesu
                            Administratora polegającego na zapewnieniu bezpieczeństwa Systemu,
                            danych oraz praw użytkowników (art. 6 ust. 1 lit. f RODO);
                        </li>
                        <li>
                            <strong>dochowanie obowiązków prawnych ciążących na Administratorze </strong>
                            (w szczególności wynikających z przepisów o rachunkowości, podatkowych lub
                            innych przepisów szczególnych) – na podstawie obowiązku prawnego
                            ciążącego na Administratorze (art. 6 ust. 1 lit. c RODO);
                        </li>
                        <li>
                            <strong>ustalenie, dochodzenie lub obrona roszczeń </strong>
                            – na podstawie uzasadnionego interesu Administratora polegającego na ochronie jego praw
                            (art. 6 ust. 1 lit. f RODO);
                        </li>
                        <li>
                            <strong>przetwarzanie danych na podstawie zgody użytkownika </strong>
                            (jeżeli w określonych sytuacjach taka zgoda jest wykorzystywana, w szczególności na
                            określone formy kontaktu) – na podstawie zgody użytkownika (art. 6 ust. 1 lit a RODO).
                        </li>
                    </ol>
                    <li>
                        Użytkownik ma prawo w każdej chwili wycofać zgodę, o której mowa w ust. 1 pkt 8,
                        przy czym wycofanie zgody nie wpływa na zgodność z prawem przetwarzania,
                        przy czym wycofanie zgody nie wpływa na zgodność z prawem przetwarzania,
                    </li>
                </ol>
            </Section>

            <Section title="§ 6. Okres przechowywania danych">
                <ol>
                    <li>
                        Dane związane z kontem w Systemie, w szczególności imię, nazwisko, adres e-mail
                        oraz numer telefonu, są przechowywane przez okres korzystania z Systemu, a
                        następnie przez okres do 3 (trzech) lat od zakończenia współpracy (w szczególności
                        usunięcia konta lub zakończenia ostatniego kursu), w celu:
                        <ol>
                            <li>ewentualnego ustalenia, dochodzenia lub obrony roszczeń,</li>
                            <li>udokumentowania przebiegu współpracy.</li>
                        </ol>
                    </li>
                    <li>
                        Dane takie jak numer PESEL, data urodzenia oraz zdjęcie, przetwarzane jedynie
                        tymczasowo na potrzeby organizacyjne, przechowywane są co do zasady nie dłużej
                        niż 6 (sześć) miesięcy od zakończenia ostatniego kursu, w którym użytkownik brał
                        udział, po czym są trwale usuwane lub anonimizowane, o ile przepisy prawa nie
                        wymagają dłuższego przechowywania.
                    </li>
                    <li>
                        Dane techniczne i eksploatacyjne, w szczególności adres IP oraz logi systemowe,
                        przechowywane są przez okres niezbędny do zapewnienia bezpieczeństwa i
                        prawidłowego działania Systemu, co do zasady nie dłużej niż 12 (dwanaście)
                        miesięcy, chyba że konieczne jest ich dłuższe przechowywanie w związku z
                        prowadzonym postępowaniem wyjaśniającym lub ochroną przed roszczeniami.
                    </li>
                    <li>
                        Dane przetwarzane na podstawie zgody użytkownika przechowywane są do czasu
                        wycofania zgody, a po jej wycofaniu – przez okres przedawnienia ewentualnych
                        roszczeń związanych z przetwarzaniem.
                    </li>
                    <li>
                        Dane mogą być przechowywane również w kopiach zapasowych tworzonych w
                        ramach standardowych procedur bezpieczeństwa. W takim przypadku dane
                        przetwarzane są wyłącznie w celu odtworzenia Systemu po awarii, przez okres
                        wynikający z cyklu tworzenia i przechowywania kopii zapasowych.
                    </li>
                </ol>
            </Section>

            <Section title="§ 7. Odbiorcy danych i podmioty przetwarzające dane w imieniu Administratora">
                <ol>
                    <li>
                        Dane osobowe użytkowników mogą być przekazywane wyłącznie podmiotom, które
                        świadczą na rzecz Administratora usługi związane z obsługą Systemu oraz działają
                        na podstawie zawartych z Administratorem umów powierzenia przetwarzania danych osobowych.
                    </li>
                    <li>
                        W szczególności dane mogą być przetwarzane przez:
                        <ol>
                            <li>dostawcę usług hostingu i infrastruktury bazodanowej <strong>Railway</strong>,</li>
                            <li>
                                dostawcę usług chmurowych <strong>Amazon Web Services</strong> (w szczególności w
                                zakresie tworzenia kopii zapasowych, obsługi poczty elektronicznej oraz
                                usług infrastrukturalnych).
                            </li>
                        </ol>
                    </li>
                    <li>
                        Podmioty, o których mowa w ust. 2, przetwarzają dane na podstawie umów
                        zawartych z Administratorem, zgodnie z RODO, wyłącznie w zakresie i w celu
                        określonym przez Administratora.
                    </li>
                    <li>
                        Dane mogą być także przekazywane:
                        <ol>
                            <li>
                                podmiotom świadczącym na rzecz Administratora usługi doradcze, prawne,
                                audytorskie lub informatyczne – w zakresie niezbędnym do realizacji tych usług,
                            </li>
                            <li>
                                organom publicznym – w zakresie, w jakim Administrator jest zobowiązany do
                                ich udostępnienia na podstawie właściwych przepisów prawa.
                            </li>
                        </ol>
                    </li>
                </ol>
            </Section>

            <Section title="§ 8. Przekazywanie danych poza Europejski Obszar Gospodarczy">
                <ol>
                    <li>
                        Co do zasady Administrator dąży do przetwarzania danych osobowych
                        użytkowników na terenie Europejskiego Obszaru Gospodarczego (EOG).
                    </li>
                    <li>
                        Jeżeli w związku z korzystaniem z określonych narzędzi lub usług dane miałyby być
                        przekazywane poza EOG, odbywa się to wyłącznie:
                        <ol>
                            <li>
                                do państw, w odniesieniu do których Komisja Europejska stwierdziła
                                odpowiedni poziom ochrony danych osobowych, lub
                            </li>
                            <li>
                                na podstawie standardowych klauzul umownych bądź innych odpowiednich
                                instrumentów przewidzianych w RODO.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Użytkownik może uzyskać dodatkowe informacje o stosowanych zabezpieczeniach
                        w drodze kontaktu z Administratorem (sekretariat@szkoladendrologii.pl).
                    </li>
                </ol>
            </Section>

            <Section title="§ 9. Prawa użytkownika">
                <ol>
                    <li>
                        Użytkownikowi, którego dane są przetwarzane przez Administratora, przysługują
                        następujące prawa:
                    </li>
                    <ol>
                        <li>prawo dostępu do danych (art. 15 RODO),</li>
                        <li>prawo do sprostowania danych (art. 16 RODO),</li>
                        <li>prawo do usunięcia danych („prawo do bycia zapomnianym”) (art. 17 RODO),</li>
                        <li>prawo do ograniczenia przetwarzania (art. 18 RODO),</li>
                        <li>prawo do przenoszenia danych (art. 20 RODO),</li>
                        <li>prawo sprzeciwu wobec przetwarzania danych (art. 21 RODO),</li>
                        <li>
                            prawo do wycofania zgody (art. 7 ust. 3 RODO), w zakresie, w jakim
                            przetwarzanie odbywa się na podstawie zgody,
                        </li>
                        <li>
                            prawo wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony
                            Danych Osobowych (PUODO).
                        </li>
                    </ol>
                    <li>
                        W celu realizacji praw, o których mowa w ust. 1, użytkownik może skontaktować się z
                        Administratorem pod adresem: <strong>sekretariat@szkoladendrologii.pl</strong>.
                    </li>
                </ol>
            </Section>

            <Section title="§ 10. Pliki cookie i podobne technologie">
                <ol>
                    <li>
                        System wykorzystuje pliki cookie (dalej: „pliki cookie”) oraz podobne technologie
                        zapisywane w urządzeniu końcowym użytkownika, zgodnie z ustawieniami
                        przeglądarki internetowej użytkownika.
                    </li>
                    <li>
                        Pliki cookie wykorzystywane są w szczególności w następujących celach:
                        <ol>
                            <li>zapewnienia prawidłowego działania i wyświetlania Systemu (pliki cookie techniczne / niezbędne),</li>
                            <li>
                                prowadzenia podstawowych statystyk dotyczących sposobu korzystania z
                                Systemu (pliki cookie statystyczne), w celu poprawy jego funkcjonalności.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Administrator może stosować następujące kategorie plików cookie:
                        <ol>
                            <li>
                                <strong>pliki cookie niezbędne (techniczne) </strong> – umożliwiają prawidłowe korzystanie z
                                Systemu, w szczególności:
                                <ul>
                                    <li>utrzymanie sesji użytkownika po zalogowaniu,</li>
                                    <li>obsługę mechanizmów bezpieczeństwa,</li>
                                    <li>zapamiętywanie ustawień użytkownika niezbędnych do działania Systemu;</li>
                                </ul>
                            </li>
                            <li>
                                <strong>pliki cookie statystyczne / analityczne</strong> – umożliwiają zbieranie informacji o
                                sposobie korzystania z Systemu (np. liczba odwiedzin, sposób nawigacji), w
                                celu poprawy działania i dostosowania Systemu do potrzeb użytkowników;
                            </li>
                            <li>
                                Administrator nie wykorzystuje plików cookie do celów marketingowych ani do
                                budowania profili użytkowników dla potrzeb reklamowych.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Pliki cookie mogą mieć charakter:
                        <ol>
                            <li>
                                <strong>sesyjny</strong> – usuwane po zakończeniu sesji (wylogowaniu lub zamknięciu przeglądarki),
                            </li>
                            <li>
                                <strong>stały</strong> – przechowywane przez określony czas lub do ich usunięcia przez użytkownika.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Podstawą prawną przetwarzania danych pozyskiwanych za pomocą plików cookie jest:
                        <ol>
                            <li>
                                w zakresie plików cookie niezbędnych – niezbędność do wykonania umowy
                                lub do podjęcia działań na żądanie użytkownika (art. 6 ust. 1 lit. b RODO)
                                oraz uzasadniony interes Administratora polegający na zapewnieniu
                                prawidłowego działania i bezpieczeństwa Systemu (art. 6 ust. 1 lit. f RODO),
                            </li>
                            <li>
                                w zakresie plików cookie statystycznych – uzasadniony interes Administratora
                                polegający na prowadzeniu analiz i statystyk w celu doskonalenia Systemu
                                (art. 6 ust. 1 lit. f RODO), a w przypadku, gdy wymagane jest uzyskanie
                                zgody użytkownika – zgoda użytkownika (art. 6 ust. 1 lit. a RODO).
                            </li>
                        </ol>
                    </li>
                    <li>
                        Użytkownik może w każdym czasie zmienić ustawienia dotyczące plików cookie za
                        pomocą ustawień przeglądarki internetowej, w szczególności poprzez:
                        <ol>
                            <li>zablokowanie automatycznej obsługi plików cookie,</li>
                            <li>żądanie informowania o ich każdorazowym zamieszczeniu w urządzeniu użytkownika.</li>
                        </ol>
                    </li>
                    <li>
                        Ograniczenie stosowania plików cookie może wpłynąć na niektóre funkcje dostępne
                        w Systemie, uniemożliwiając prawidłowe korzystanie z niego w pełnym zakresie.
                    </li>
                </ol>
            </Section>

            <Section title="§ 11. Środki bezpieczeństwa danych">
                <ol>
                    <li>
                        Administrator stosuje odpowiednie środki techniczne i organizacyjne mające na celu
                        zapewnienie ochrony przetwarzanych danych osobowych, odpowiadające ryzyku
                        naruszenia praw lub wolności użytkowników.
                    </li>
                    <li>
                        W szczególności Administrator zapewnia, że:
                        <ol>
                            <li>
                                hasła użytkowników przechowywane są w bazie danych w postaci
                                zaszyfrowanej (z wykorzystaniem standardu bcrypt),
                            </li>
                            <li>
                                dostęp do Systemu zabezpieczony jest mechanizmami autoryzacji,
                            </li>
                            <li>
                                dostęp do danych mają wyłącznie osoby upoważnione, zobowiązane do
                                zachowania poufności,
                            </li>
                            <li>
                                wykorzystywane są mechanizmy monitorowania bezpieczeństwa i logowania zdarzeń.
                            </li>
                        </ol>
                    </li>
                </ol>
            </Section>

            <Section title="§ 12. Zautomatyzowane podejmowanie decyzji i profilowanie">
                <p>
                    Dane osobowe użytkowników Systemu nie są wykorzystywane do zautomatyzowanego
                    podejmowania decyzji ani profilowania w rozumieniu art. 22 RODO.
                </p>
            </Section>

            <Section title="§ 13. Zmiany Polityki prywatności">
                <ol>
                    <li>
                        Administrator może okresowo aktualizować niniejszą Politykę, w szczególności w przypadku:
                        <ol>
                            <li>zmian w funkcjonowaniu Systemu,</li>
                            <li>zmian obowiązujących przepisów prawa,</li>
                            <li>wydania nowych wytycznych przez organy nadzorcze.</li>
                        </ol>
                    </li>
                    <li>
                        O istotnych zmianach Polityki użytkownicy zostaną poinformowani z odpowiednim
                        wyprzedzeniem, poprzez komunikat w Systemie lub inną odpowiednią drogą.
                    </li>
                    <li>
                        Nowa wersja Polityki obowiązuje od dnia wskazanego w jej treści jako data aktualizacji.
                    </li>
                </ol>
            </Section>

            <p className="footer">
                W razie pytań lub wątpliwości dotyczących niniejszej Polityki oraz przetwarzania danych
                osobowych w związku z korzystaniem z Systemu prosimy o kontakt pod adresem: <strong>sekretariat@szkoladendrologii.pl</strong>
            </p>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section className="section-block">
            <h2 className="section-title">{title}</h2>
            <div className="section-content">{children}</div>
        </section>
    );
}
